import React from 'react';

const FooterLogo = () => {
    return (
        <div className="logo logo-primary">
            <img src={ process.env.PUBLIC_URL + "/assets/img/logo/logo-dark.svg" } alt="Logo Przychodni na Pańskiej" />
        </div>
    );
};

export default FooterLogo;
